import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

import {
  BaseInputComponent,
  InputType,
} from '../../../common/base-input.component';

@Component({
  selector: 'nibtravel-checkbox',
  templateUrl: './checkbox.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent extends BaseInputComponent {
  @HostBinding('class') class = 'checkbox';

  /** The HTML checked attribute */
  @Input() checked = false;

  type: InputType = 'checkbox';

  onError(errors: string[]): void {
    this.error.emit(errors);
  }
}
